export const baseApiURL = () => {
  return process.env.REACT_APP_APILINK;
};

/** Origin for static `/media` (strip trailing `/api` from API base). */
export const publicMediaBase = () => {
  const api = baseApiURL() || "http://localhost:4000/api"
  return api.replace(/\/?api\/?$/i, "").replace(/\/$/, "") || ""
}

/** Full URL for a path like `/media/123.jpg`. */
export const mediaFileUrl = (path) => {
  if (!path) return ""
  const p = String(path).trim()
  if (/^https?:\/\//i.test(p)) return p
  const rel = p.startsWith("/") ? p : `/${p}`
  return `${publicMediaBase()}${rel}`
}

/**
 * Socket.IO attaches to the same HTTP server as the API, but without the `/api` path.
 * Set `REACT_APP_SOCKET_URL` in production (e.g. https://your-api.example.com).
 */
export const socketServerURL = () => {
  const explicit = process.env.REACT_APP_SOCKET_URL;
  if (explicit && String(explicit).trim()) {
    return String(explicit).trim().replace(/\/$/, "");
  }
  const api = process.env.REACT_APP_APILINK || "http://localhost:4000/api";
  const stripped = api.replace(/\/?api\/?$/i, "").replace(/\/$/, "");
  return stripped || "http://localhost:4000";
};
